import { getSaleDetail, SaleAlreadyVoidedError } from '../../sales/public-api';

export type RecoveredPendingSale = {
  counterNumber?: number | null;
  pickupName?: string | null;
  fulfillmentType?: string | null;
};

/**
 * Recuperación determinística tras un intento de cobro ambiguo: si el request
 * anterior commiteó en el server pero el response se perdió (corte de red),
 * la venta ya existe bajo el saleId reservado. Consultamos ese id exacto:
 *
 * - existe y está activa → devolvemos sus datos para retomar el flujo post-venta
 *   (emisión fiscal + impresión) sin llamar createSale ni duplicar nada.
 * - existe y está anulada → SaleAlreadyVoidedError (el checkout descarta el id).
 * - no existe o la consulta falla → null: createSale con el mismo saleId
 *   resuelve vía el upsert idempotente del sale command.
 */
export async function recoverPendingPosSale(saleId: string): Promise<RecoveredPendingSale | null> {
  const prior = await getSaleDetail(saleId).catch(() => null);
  if (!prior) return null;
  if (prior.status === 'voided') throw new SaleAlreadyVoidedError();
  return {
    counterNumber: prior.counterNumber ?? null,
    pickupName: prior.pickupName ?? null,
    fulfillmentType: prior.fulfillmentType ?? null,
  };
}
